// Launcher Actions
export const APP_LAUNCHED = 'LAUNCH_APP';
export const APP_QUIT = 'APP_QUIT';

// Invite Actions
export const ADD_INVITE = 'ADD_INVITE';

export const CREATE_INVITE = 'CREATE_INVITE';
export const CREATE_INVITE_PENDING = 'CREATE_INVITE_PENDING';
export const CREATE_INVITE_FULFILLED = 'CREATE_INVITE_FULFILLED';
export const CREATE_INVITE_REJECTED = 'CREATE_INVITE_REJECTED';

export const FETCH_INVITES = 'FETCH_INVITES';
export const FETCH_INVITES_PENDING = 'FETCH_INVITES_PENDING';
export const FETCH_INVITES_FULFILLED = 'FETCH_INVITES_FULFILLED';
export const FETCH_INVITES_REJECTED = 'FETCH_INVITES_REJECTED';

export const RESEND_INVITE = 'RESEND_INVITE';
export const RESEND_INVITE_PENDING = 'RESEND_INVITE_PENDING';
export const RESEND_INVITE_FULFILLED = 'RESEND_INVITE_FULFILLED';
export const RESEND_INVITE_REJECTED = 'RESEND_INVITE_REJECTED';

export const CANCEL_INVITE = 'CANCEL_INVITE';
export const CANCEL_INVITE_PENDING = 'CANCEL_INVITE_PENDING';
export const CANCEL_INVITE_FULFILLED = 'CANCEL_INVITE_FULFILLED';
export const CANCEL_INVITE_REJECTED = 'CANCEL_INVITE_REJECTED';

// Session Actions
export const REQUEST_USER_LOGIN = 'REQUEST_USER_LOGIN';
export const REQUEST_USER_LOGIN_PENDING = 'REQUEST_USER_LOGIN_PENDING';
export const REQUEST_USER_LOGIN_FULFILLED = 'REQUEST_USER_LOGIN_FULFILLED';
export const REQUEST_USER_LOGIN_REJECTED = 'REQUEST_USER_LOGIN_REJECTED';

export const REQUEST_USER_LOGOUT = 'REQUEST_USER_LOGOUT';

export const REQUEST_ROOM_CHANGE = 'REQUEST_ROOM_CHANGE';
export const REVIVE_SESSION = 'REVIVE_SESSION';
export const UPDATE_CACHED_USER = 'UPDATE_CACHED_USER';

export const REQUEST_UPDATE_USER = 'REQUEST_UPDATE_USER';
export const REQUEST_UPDATE_USER_PENDING = 'REQUEST_UPDATE_USER_PENDING';
export const REQUEST_UPDATE_USER_FULFILLED = 'REQUEST_UPDATE_USER_FULFILLED';
export const REQUEST_UPDATE_USER_REJECTED = 'REQUEST_UPDATE_USER_REJECTED';

export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET';
export const REQUEST_PASSWORD_RESET_PENDING = 'REQUEST_PASSWORD_RESET_PENDING';
export const REQUEST_PASSWORD_RESET_FULFILLED = 'REQUEST_PASSWORD_RESET_FULFILLED';
export const REQUEST_PASSWORD_RESET_REJECTED = 'REQUEST_PASSWORD_RESET_REJECTED';

// Friends Actions
export const FRIENDS_REQUEST_LIST = 'FRIENDS_REQUEST_LIST';
export const FRIENDS_REQUEST_LIST_PENDING = 'FRIENDS_REQUEST_LIST_PENDING';
export const FRIENDS_REQUEST_LIST_FULFILLED = 'FRIENDS_REQUEST_LIST_FULFILLED';
export const FRIENDS_REQUEST_LIST_REJECTED = 'FRIENDS_REQUEST_LIST_REJECTED';

export const FRIENDS_REQUEST_ADD_FRIEND = 'FRIENDS_REQUEST_ADD_FRIEND';
export const FRIENDS_REQUEST_ADD_FRIEND_PENDING = 'FRIENDS_REQUEST_ADD_FRIEND_PENDING';
export const FRIENDS_REQUEST_ADD_FRIEND_FULFILLED = 'FRIENDS_REQUEST_ADD_FRIEND_FULFILLED';
export const FRIENDS_REQUEST_ADD_FRIEND_REJECTED = 'FRIENDS_REQUEST_ADD_FRIEND_REJECTED';

export const FRIENDS_SEARCH_USER = 'FRIENDS_SEARCH_USER';
export const FRIENDS_SEARCH_USER_PENDING = 'FRIENDS_SEARCH_USER_PENDING';
export const FRIENDS_SEARCH_USER_FULFILLED = 'FRIENDS_SEARCH_USER_FULFILLED';
export const FRIENDS_SEARCH_USER_REJECTED = 'FRIENDS_SEARCH_USER_REJECTED';
export const FRIENDS_CLEAR_SEARCH_USER = 'FRIENDS_CLEAR_SEARCH_USER';

// Rooms Actions
export const ROOMS_REQUEST_LIST = 'ROOMS_REQUEST_LIST';
export const ROOMS_REQUEST_LIST_PENDING = 'ROOMS_REQUEST_LIST_PENDING';
export const ROOMS_REQUEST_LIST_FULFILLED = 'ROOMS_REQUEST_LIST_FULFILLED';
export const ROOMS_REQUEST_LIST_REJECTED = 'ROOMS_REQUEST_LIST_REJECTED';

export const ROOMS_CREATE_ROOM = 'ROOMS_CREATE_ROOM';
export const ROOMS_CREATE_ROOM_PENDING = 'ROOMS_CREATE_ROOM_PENDING';
export const ROOMS_CREATE_ROOM_FULFILLED = 'ROOMS_CREATE_ROOM_FULFILLED';
export const ROOMS_CREATE_ROOM_REJECTED = 'ROOMS_CREATE_ROOM_REJECTED';
export const ROOMS_CLEAR_CREATED_ROOM = 'ROOMS_CLEAR_CREATED_ROOM';

export const ROOMS_JOIN_ROOM = 'ROOMS_JOIN_ROOM';

export const ROOMS_INVITE_USERS = 'ROOMS_INVITE_USERS';
export const ROOMS_INVITE_USERS_PENDING = 'ROOMS_INVITE_USERS_PENDING';
export const ROOMS_INVITE_USERS_FULFILLED = 'ROOMS_INVITE_USERS_FULFILLED';
export const ROOMS_INVITE_USERS_REJECTED = 'ROOMS_INVITE_USERS_REJECTED';
export const ROOMS_CLEAR_INVITE_USERS = 'ROOMS_CLEAR_INVITE_USERS';

export const ROOMS_UPDATE_ROOM = 'ROOMS_UPDATE_ROOM';
export const ROOMS_UPDATE_ROOM_PENDING = 'ROOMS_UPDATE_ROOM_PENDING';
export const ROOMS_UPDATE_ROOM_FULFILLED = 'ROOMS_UPDATE_ROOM_FULFILLED';
export const ROOMS_UPDATE_ROOM_REJECTED = 'ROOMS_UPDATE_ROOM_REJECTED';

export const ROOMS_DELETE_ROOM = 'ROOMS_DELETE_ROOM';
export const ROOMS_DELETE_ROOM_PENDING = 'ROOMS_DELETE_ROOM_PENDING';
export const ROOMS_DELETE_ROOM_FULFILLED = 'ROOMS_DELETE_ROOM_FULFILLED';
export const ROOMS_DELETE_ROOM_REJECTED = 'ROOMS_DELETE_ROOM_REJECTED';

export const ROOMS_REQUEST_REMOVE_MEMBERS = 'ROOMS_REQUEST_REMOVE_MEMBERS';
export const ROOMS_REQUEST_REMOVE_MEMBERS_PENDING = 'ROOMS_REQUEST_REMOVE_MEMBERS_PENDING';
export const ROOMS_REQUEST_REMOVE_MEMBERS_FULFILLED = 'ROOMS_REQUEST_REMOVE_MEMBERS_FULFILLED';
export const ROOMS_REQUEST_REMOVE_MEMBERS_REJECTED = 'ROOMS_REQUEST_REMOVE_MEMBERS_REJECTED';

// Backpack Actions
export const BACKPACK_REQUEST_LIST = 'BACKPACK_REQUEST_LIST';
export const BACKPACK_REQUEST_LIST_PENDING = 'BACKPACK_REQUEST_LIST_PENDING';
export const BACKPACK_REQUEST_LIST_FULFILLED = 'BACKPACK_REQUEST_LIST_FULFILLED';
export const BACKPACK_REQUEST_LIST_REJECTED = 'BACKPACK_REQUEST_LIST_REJECTED';

export const BACKPACK_DELETE_ITEM = 'BACKPACK_DELETE_ITEM';
export const BACKPACK_DELETE_ITEM_PENDING = 'BACKPACK_DELETE_ITEM_PENDING';
export const BACKPACK_DELETE_ITEM_FULFILLED = 'BACKPACK_DELETE_ITEM_FULFILLED';
export const BACKPACK_DELETE_ITEM_REJECTED = 'BACKPACK_DELETE_ITEM_REJECTED';

// Notification Actions
export const NOTIFICATIONS_REQUEST_LIST = 'NOTIFICATIONS_REQUEST_LIST';
export const NOTIFICATIONS_REQUEST_LIST_PENDING = 'NOTIFICATIONS_REQUEST_LIST_PENDING';
export const NOTIFICATIONS_REQUEST_LIST_FULFILLED = 'NOTIFICATIONS_REQUEST_LIST_FULFILLED';
export const NOTIFICATIONS_REQUEST_LIST_REJECTED = 'NOTIFICATIONS_REQUEST_LIST_REJECTED';

export const NOTIFICATION_ACCEPT = 'NOTIFICATION_ACCEPT';
export const NOTIFICATION_ACCEPT_PENDING = 'NOTIFICATION_ACCEPT_PENDING';
export const NOTIFICATION_ACCEPT_FULFILLED = 'NOTIFICATION_ACCEPT_FULFILLED';
export const NOTIFICATION_ACCEPT_REJECTED = 'NOTIFICATION_ACCEPT_REJECTED';

export const NOTIFICATION_DECLINE = 'NOTIFICATION_DECLINE';
export const NOTIFICATION_DECLINE_PENDING = 'NOTIFICATION_DECLINE_PENDING';
export const NOTIFICATION_DECLINE_FULFILLED = 'NOTIFICATION_DECLINE_FULFILLED';
export const NOTIFICATION_DECLINE_REJECTED = 'NOTIFICATION_DECLINE_REJECTED';


// Admin Actions
export const ADMIN_REQUEST_STEAM_KEY_COUNT = 'ADMIN_REQUEST_STEAM_KEY_COUNT';
export const ADMIN_REQUEST_STEAM_KEY_COUNT_PENDING = 'ADMIN_REQUEST_STEAM_KEY_COUNT_PENDING';
export const ADMIN_REQUEST_STEAM_KEY_COUNT_FULFILLED = 'ADMIN_REQUEST_STEAM_KEY_COUNT_FULFILLED';
export const ADMIN_REQUEST_STEAM_KEY_COUNT_REJECTED = 'ADMIN_REQUEST_STEAM_KEY_COUNT_REJECTED';

export const ADMIN_REQUEST_ADD_STEAM_KEYS = 'ADMIN_REQUEST_ADD_STEAM_KEYS';
export const ADMIN_REQUEST_ADD_STEAM_KEYS_PENDING = 'ADMIN_REQUEST_ADD_STEAM_KEYS_PENDING';
export const ADMIN_REQUEST_ADD_STEAM_KEYS_FULFILLED = 'ADMIN_REQUEST_ADD_STEAM_KEYS_FULFILLED';
export const ADMIN_REQUEST_ADD_STEAM_KEYS_REJECTED = 'ADMIN_REQUEST_ADD_STEAM_KEYS_REJECTED';

export const ADMIN_REQUEST_PENDING_INVITES = 'ADMIN_REQUEST_PENDING_INVITES';
export const ADMIN_REQUEST_PENDING_INVITES_PENDING = 'ADMIN_REQUEST_PENDING_INVITES_PENDING';
export const ADMIN_REQUEST_PENDING_INVITES_FULFILLED = 'ADMIN_REQUEST_PENDING_INVITES_FULFILLED';
export const ADMIN_REQUEST_PENDING_INVITES_REJECTED = 'ADMIN_REQUEST_PENDING_INVITES_REJECTED';

export const ADMIN_REQUEST_APPROVE_INVITE = 'ADMIN_REQUEST_APPROVE_INVITE';
export const ADMIN_REQUEST_APPROVE_INVITE_PENDING = 'ADMIN_REQUEST_APPROVE_INVITE_PENDING';
export const ADMIN_REQUEST_APPROVE_INVITE_FULFILLED = 'ADMIN_REQUEST_APPROVE_INVITE_FULFILLED';
export const ADMIN_REQUEST_APPROVE_INVITE_REJECTED = 'ADMIN_REQUEST_APPROVE_INVITE_REJECTED';

export const ADMIN_REQUEST_CANCEL_INVITE = 'ADMIN_REQUEST_CANCEL_INVITE';
export const ADMIN_REQUEST_CANCEL_INVITE_PENDING = 'ADMIN_REQUEST_CANCEL_INVITE_PENDING';
export const ADMIN_REQUEST_CANCEL_INVITE_FULFILLED = 'ADMIN_REQUEST_CANCEL_INVITE_FULFILLED';
export const ADMIN_REQUEST_CANCEL_INVITE_REJECTED = 'ADMIN_REQUEST_CANCEL_INVITE_REJECTED';

// Popover Actions
export const POPOVERS_OPEN_POPOVER = 'POPOVERS_OPEN_POPOVER';
export const POPOVERS_CLOSE_POPOVER = 'POPOVERS_CLOSE_POPOVER';



// WEBPACK FOOTER //
// ./src/actions/action-types.js